module.exports = __webpack_public_path__ + "img/home-index-menu8.041b336d.png";